module.exports = __webpack_public_path__ + "img/bullhorn-solid.30d1a4c1.svg";